module.exports = __webpack_public_path__ + "static/media/SIFUTUROLOGO.722028f0.png";